export const formatPhone = (phone) => {
  const digits = phone.replace(/\D/g, '');
  if (digits.length === 0) return '';
  if (digits.length <= 3) {
    return digits;
  } else if (digits.length <= 6) {
    return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  } else {
    const cappedDigits = digits.slice(0, 10);
    return `${cappedDigits.slice(0, 3)}-${cappedDigits.slice(3, 6)}-${cappedDigits.slice(6)}`;
  }
};